import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/left-block/left-block.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/left-block/bread-crumbs/bread-crumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ParcelingItem"] */ "/usr/src/app/src/components/left-block/parceling-item/parceling-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BannerLG"] */ "/usr/src/app/src/components/right-block/banner-lg/banner-lg.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/right-block/block-sm/block-sm.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/loading/loading.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/right-block/right-block.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ImageModify"] */ "/usr/src/app/src/components/ui/image-modify/image-modify.tsx");
